var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.28,
    height: 87.7,
    viewBox: "0 0 71 40.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.8,49.358h0a57.419,57.419,0,0,1-15.648-2.181A57.667,57.667,0,0,1,35,45.056V20.673a34.136,34.136,0,0,0,14.991,3.451c11.777,0,22.561-5.937,27.474-15.124H106a42.007,42.007,0,0,1-9.877,23.052,48.651,48.651,0,0,1-22.786,14.8A55.415,55.415,0,0,1,56.8,49.358Z",
    transform: "translate(-35 -9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.a40803bd.svg";
export { ForwardRef as ReactComponent };